import { TaskCategoryEntityTypeConfig } from './TasksTable'

export const taskCategoryEntityType: Record<string, TaskCategoryEntityTypeConfig> = {
  wealthbox: { api: 'task_categories', dto: 'taskCategories' },
  redtail: { api: 'categories', dto: 'categories' },
  smartoffice: { api: 'static', dto: 'static' },
}
